(function () {
  const PRODUCT_MAPS = {
    y813: {
      handles: [
        'y813bt-bluetooth-thermal-label-printer-white',
        'y813bt-bluetooth-thermal-label-printer-black',
        'y813bt-bluetooth-thermal-label-printer-pink',
      ],
      colors: {
        white: 'y813bt-bluetooth-thermal-label-printer-white',
        black: 'y813bt-bluetooth-thermal-label-printer-black',
        pink: 'y813bt-bluetooth-thermal-label-printer-pink',
      },
    },
    y41bt: {
      handles: [
        'y41bt-bluetooth-thermal-label-printer-white',
        'y41bt-bluetooth-thermal-label-printer-black',
      ],
      colors: {
        white: 'y41bt-bluetooth-thermal-label-printer-white',
        black: 'y41bt-bluetooth-thermal-label-printer-black',
      },
    },
  };

  function getLangPrefix() {
    const match = window.location.pathname.match(/^\/([\w-]{2,5})\//);
    const excluded = ['products', 'collections', 'pages', 'blogs', 'cart'];
    if (match && !excluded.includes(match[1])) {
      return '/' + match[1];
    }
    return '';
  }

  function getCurrentProductMap() {
    const pathname = window.location.pathname;

    return Object.values(PRODUCT_MAPS).find((product) =>
      product.handles.some((handle) => pathname.endsWith('/products/' + handle))
    );
  }

  function init() {
    const swatches = document.querySelectorAll('input[type="radio"][name="Color"]');
    swatches.forEach((el) => {
      el.addEventListener('change', handleChange);
    });
  }

  function handleChange(e) {
    const productMap = getCurrentProductMap();
    if (!productMap) return;

    const value = e.target.value.toLowerCase();
    const handle = productMap.colors[value];

    if (handle && !window.location.pathname.endsWith('/products/' + handle)) {
      window.location.href = getLangPrefix() + '/products/' + handle;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();